export default __webpack_public_path__ + "static/media/Entrance.21c38dee.jpeg";